export const EMAIL_CHANGE_MARK = 'email-change=';

export const EMAIL_CHANGE_PATH = '/auth/email-change';

export const RECOVERY_PATH = '/auth/reset';
